import { StyleSheet, View } from "react-native";

import { makeStyles } from "@/theme/makeStyles";
import { Text } from "@/ui/Text";

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    bar: {
      minHeight: t.size.touchTarget + t.space.md,
      paddingHorizontal: t.space.lg,
      justifyContent: "center",
      // Same quiet chrome as the school header: page ground, no rule.
      backgroundColor: t.color.background,
    },
  }),
);

/**
 * The no-school header: the text "Akaiva Edu Power", never a logo (FR-027; R-9). Used before a school
 * is known: loading, entry, public addresses, not-found.
 */
export function ProductHeader() {
  const styles = useStyles();
  return (
    <View style={styles.bar} role="banner">
      <Text variant="heading" weight="light" size="xl">
        Akaiva Edu Power
      </Text>
    </View>
  );
}
